<template>
  <div>
    <card title="İşlər">
      <div class="row">
        <div class="col-10">
        </div>
      </div>
      <el-form v-loading="loading">
        <div @dblclick="clickCard(item.id)" class="row" v-for="item in claims" :key="item.id">
          <div class="col-12">
            <claim-card :item="item"  :readonly="false" @refresh="getData" />
          </div>
        </div>
      </el-form>
    </card>
    <el-collapse v-loading="loading" value="1">
      <el-collapse-item name="1">
        <template #title>
          <div style="margin-left: 7px;"> 
            <i class="fa-solid fa-headphones-simple"></i>
            &nbsp;
            <span>{{ $t('Çağrı_mərkəzinin_qeydləri') }}</span>
          </div>
        </template>
        <accident-base :value="item"></accident-base>
      </el-collapse-item>
    </el-collapse>
    <el-collapse v-loading="loading" value="2">
      <el-collapse-item name="2">
        <template #title>
          <div style="margin-left: 7px;">
            <i class="fa-solid fa-person-military-pointing"></i>
            &nbsp;
            <span>{{$t('Komissarın_qeydləri')}}</span>
          </div>
        </template>
        <accident-comm-base :value="comm"></accident-comm-base>
      </el-collapse-item>
    </el-collapse>

    <el-collapse v-loading="loading" value="3">
      <el-collapse-item name="3">
        <template #title>
          <div style="margin-left: 7px;">
          <i class="fa-solid fa-people-arrows-left-right"></i>
          &nbsp;
          <span>{{$t('İştirakçılar')}}</span>
          </div>
        </template>
        <card>
          <el-form v-loading="partloading">
            <div class="row">
              <div class="col-md-6 col-12" v-for="item in participants" :key="item.id">
                <div v-if="item.policyType === null || item.policyType === 1">
                  <participant-card :item="item" :readonly="true" @refresh="getParticipants"
                    @edit="editParticipant(item)" @delete="deleteParticipant" @report="reportParticipant(item)" />
                </div>
                <div v-else>
                  <other-participant-card :item="item" :readonly="true"  @refresh="getParticipants"
                    @edit="editParticipant(item)" @delete="deleteParticipant" @report="reportParticipant(item)" />
                </div>
              </div>
            </div>
          </el-form>
        </card>
      </el-collapse-item>
    </el-collapse>

    <participant ref="participant" @saved="getParticipants" />
    <report-participant ref="report" @saved="getParticipants" />
    <other-participant ref="otherParticipant" @saved="getParticipants" />
  </div>
</template>

<script>
import {
  GetAccident,
  GetCommData,
  GetParticipants,
  GetAccidentsByStatus,
} from "../../services/accident";
import { GetClaimParticipants } from "../../services/common";
import Participant from "../components/Participant.vue";
import ParticipantCard from "../components/ParticipantCard.vue";
import ClaimCard from "../components/ClaimCard.vue";
import AccidentBase from "../components/AccidentBase.vue";
import AccidentCommBase from "../components/AccidentCommBase.vue";
import ReportParticipant from "../components/ReportParticipant.vue";
import OtherParticipantCard from "../components/OtherParticipantCard.vue";
export default {
  props: {
    id: [String, Number],
  },
  components: {
    Participant,
    ClaimCard,
    AccidentBase,
    AccidentCommBase,
    ParticipantCard,
    ReportParticipant,
    OtherParticipantCard
  },
  data() {
    return {
      loading: false,
      commloading: false,
      partloading: false,
      item: {},
      comm: {},
      data: {},
      participants: [],
      claims: {},
      uid: this.$store.state.user.id,
    };
  },
  methods: {
    clickCard(id) {
      this.$router.push({
        path: "../claim/" + id,
      });
    },
    map() {
      this.$refs["mapcontrol"].show(this.comm.lat, this.comm.lng);
    },

    reportParticipant(id, accidentId, createUserId) {
      this.$refs["report"].edit(id, accidentId, createUserId,false);
    },

        editParticipant(id) {
      this.$refs["participant"].edit(id);
    },
    getCommData() {
      this.commloading = true;
      GetCommData(this.id).then((response) => {
        this.commloading = false;
          if (response && response.data && response.data.data && response.data.data?.[0]) {
      this.comm = response.data.data?.[0];
    } else {
      // Boş bir nesne oluştur, hiçbir zaman null olmasın
      this.comm = {};
    }
      });
    },

    getData() {
      this.loading = true;
      GetAccident(this.id).then((response) => {
        this.loading = false;
        if (response.data.data) {
           this.item = response.data.data?.[0]
          this.getCommData();
          this.getParticipants();
          this.getDataByStatus();
          this.getClaimParticipants();
        } else {
          this.$message({
            type: "warning",
            message: "Səhv əməliyyat",
          });
        }
      });
    },
   
    getDataByStatus() {
      this.loading = true;
      GetAccidentsByStatus(this.id, 0, 40, this.uid).then((response) => {
        this.loading = false;
        if (response.data.data) {
          this.data = response.data.data;
        } else {
          this.data = null;
        }
      });
    },
    getParticipants() {
      this.partloading = true;
      GetParticipants(this.id).then((response) => {
        this.partloading = false;
        if (response.data.data) {
          this.participants = response.data.data;
        }
      });
    },
    getClaimParticipants() {
      this.partloading = true;
      GetClaimParticipants(this.id).then((response) => {
        this.partloading = false;
        if (response.data.data) {
          this.claims = response.data.data;
        }
      });
    },



  },

  mounted() {
    this.getData();
  },
};
</script>

<style lang="scss" scoped></style>